<template>
  <div class="">
    <main class="main">
      <section class="section only-bottom">
        <div class="container container--medium">
          <NoGoalAlert />
          <ProgressCard v-if="isGoalSet" />
          <!--<div class="tabs-line season__view-switcher">
            <ul class="tabs-line-content">
              <li>
                <button
                  class="tabs-line__item"
                  :class="{ active: viewMode === 'general' }"
                  @click="viewMode = 'general'"
                >
                  Общий рейтинг
                </button>
              </li>
              <li v-if="hasClustersRating">
                <button
                  class="tabs-line__item"
                  :class="{ active: viewMode === 'cluster' }"
                  @click="viewMode = 'cluster'"
                >
                  Рейтинги по кластерам
                </button>
              </li>
            </ul>
          </div>
          -->
          <div class="statistic" :class="{ 'loading': loading || ratingLoading.rating }">
            <div class="statistic__top">
              <div class="statistic__title">
                Рейтинг за <span></span>
                <div v-click-outside="onClickOutside" class="statistic__title-open" :class="{ 'active': showDate }"
                  @click="toggleShowDate">
                  <div class="statistic__title-open-text">{{ activeMonth ? activeMonth : activePeriod ? activePeriod : 'весь проект' }}</div>
                  <i class="fa-solid fa-chevron-down"></i>

                  <div v-if="showDate" class="statistic__dropdown active" :class="{ 'with-sidebar': showSidebarMonth || showSidebarSeason }">

                    <a href="javascript:void(0)" class="statistic__dropdown-item" @mouseover="showSidebarMonth = true;showSidebarSeason=false;" @mouseleave="showSidebarMonth = false;" @click="showSidebarMonth=true;showSidebarSeason=false;">
                      <span class="statistic__dropdown-title">Месяц</span>
                    </a>

                    <div class="statistic__dropdown sidebar active" v-show="showSidebarMonth" @mouseover="showSidebarMonth = true;showSidebarSeason=false;" @mouseleave="showSidebarMonth = false;" @click="showSidebarMonth=true;showSidebarSeason=false;">
                      <a href="javascript:void(0)" v-for="(date, index) in monthsArray" :key="index" class="statistic__dropdown-item sidebar-item"
                        @click="setActiveMonth(date)">
                        <span class="statistic__dropdown-title">{{ $moment(date).format("MMMM YYYY") }}</span>
                      </a>
                    </div>

                    <a href="javascript:void(0)" class="statistic__dropdown-item" @mouseover="showSidebarSeason = true" @mouseleave="showSidebarSeason = false">
                      <span class="statistic__dropdown-title">Сезон</span>
                    </a>

                    <div class="statistic__dropdown sidebar active" v-show="showSidebarSeason" @mouseover="showSidebarSeason = true" @mouseleave="showSidebarSeason = false">
                      <a href="javascript:void(0)" class="statistic__dropdown-item sidebar-item" @click="setActivePeriod('summer2026')">
                        <span class="statistic__dropdown-title"><span class="period-title">Летний сезон 2026</span> <br><small>(1.05 — 30.09)</small></span>
                      </a>
                      <a href="javascript:void(0)" class="statistic__dropdown-item sidebar-item" @click="setActivePeriod('winter2025-26')">
                        <span class="statistic__dropdown-title"><span class="period-title">Зимний сезон 2026</span> <br><small>(1.12.2025 — 31.03.2026)</small></span>
                      </a>
                      <a href="javascript:void(0)" class="statistic__dropdown-item sidebar-item" @click="setActivePeriod('summer2025')">
                        <span class="statistic__dropdown-title"><span class="period-title">Летний сезон 2025</span> <br><small>(1.05 — 30.09)</small></span>
                      </a>
                      <a href="javascript:void(0)" class="statistic__dropdown-item sidebar-item" @click="setActivePeriod('winter')">
                        <span class="statistic__dropdown-title"><span class="period-title">Зимний сезон 2025</span> <br><small>(1.01 — 31.03)</small></span>
                      </a>
                      <a href="javascript:void(0)" class="statistic__dropdown-item sidebar-item" @click="setActivePeriod('summer')">
                        <span class="statistic__dropdown-title"><span class="period-title">Летний сезон 2024</span> <br><small>(1.05 — 30.09)</small></span>
                      </a>
                    </div>
                    
                    <a href="javascript:void(0)" class="statistic__dropdown-item" @click="setAllProject()">
                      <span class="statistic__dropdown-title">За весь проект</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <ul class="tabs">
              <li>
                <button class="tabs__item js-nav-personal-programs" :class="{ 'active': !params.type_group && !params.type }"
                @click="setTypeAll">
                  Все тренировки
                </button>
              </li>
              <template v-if="trainingType && trainingType.groups">
                <li
                  v-for="item in trainingType.groups.filter(f => f.code == 'running' || f.code == 'walking' || f.code == 'biking' || f.code == 'swimming')"
                  :key="item.code">
                  <button :disabled="ratingLoading.rating" class="tabs__item js-nav-personal-programs"
                    :class="{ 'active': params.type_group && params.type_group == item.code }"
                    @click="setTypeFilter(item.code, 'type_group')">
                    <img v-if="item.icon" :src="item.icon.url" style="width: 25px;"
                      :class="{ 'active-icon': params.type_group && params.type_group == item.code }" />
                    {{ item.name }}
                  </button>
                </li>
              </template>
            </ul>
            <div class="tabs-line">
              <ul class="tabs-line-content">
                <li>
                  <button 
                    :disabled="ratingLoading.rating"
                    class="tabs-line__item"
                    :class="{ active: activeTab === 'all' }"
                    @click="setActiveTab('all')"
                  >
                    Все участники
                  </button>
                </li>
                <li>
                  <button 
                    v-if="group !== null"
                    :disabled="ratingLoading.rating"
                    class="tabs-line__item"
                    :class="{ active: activeTab === 'group' }"
                    @click="setActiveTab('group')"
                  >
                    Моя группа
                  </button>

                  <button 
                    v-else
                    class="tabs-line__item"
                    @click="showModal"
                  >
                    Моя группа
                  </button>
                </li>
                <li>
                  <button
                    v-if="subunit !== null && group !== null"
                    :disabled="ratingLoading.rating"
                    class="tabs-line__item"
                    :class="{ active: activeTab === 'subunit' }"
                    @click="setActiveTab('subunit')"
                  >
                    Мое подразделение
                  </button>
                  <button
                    v-else
                    class="tabs-line__item"
                    @click="showModal"
                  >
                    Мое подразделение
                  </button>
                </li>
              </ul>
            </div>
            <div v-if="ratingLoading.rating" class="statistic__body" style="display: flex; align-items: center;">
              <span class="loader"></span>
            </div>
            <template v-else>
              <div class="distance" v-if="total">
                <div class="distance__text">
                  Суммарная дистанция: <strong>{{total.distance_km.toLocaleString()}} км</strong>
                </div>
              </div>
              <div class="rating__body">
                <div class="rating__position" v-if="repsonal_rating && repsonal_rating.place > 0">
                  <p class="rating__position-text">Ваша позиция в рейтинге</p>
                  <p class="rating__position-item">{{ repsonal_rating.place }}</p>
                </div>
                <ul class="rating__list" v-if="rating.length > 0">
                  <li class="rating__list-item" v-for="item in rating" :key="item.id">
                    <p class="rating__list-number">{{ item.place }}</p>
                    <div class="rating__list-avatar">
                      <img v-if="item && item.member && item.member.avatar && item.member.avatar.url" :src="item.member.avatar.url" alt="" class="rating__list-img">
                      <img v-else src="@/assets/img/no-avatar.jpg" alt="" class="rating__list-img">
                    </div>
                    <p class="rating__list-name">{{ item.member.name }}</p>
                    <p class="rating__list-value">{{ item.distance_km }} км</p>
                  </li>
                </ul>
                <infinite-loading @infinite="infiniteHandler" :identifier="infiniteId" :activeTab="activeTab">
                  <span slot="spinner" class="loader" style="margin-top: 15px;"></span>
                  <div slot="no-more"></div>
                  <div slot="no-results"></div>
                </infinite-loading>
                <div v-if="rating.rating == []">Тренировок нет</div>
              </div>
            </template>
          </div>
        <!--
        <div class="season__clusters" v-show="viewMode === 'cluster' && hasClustersRating">
          <ul class="tabs season__cluster-activity">
            <li>
              <button
                type="button"
                class="tabs__item"
                :class="{ active: clusterActivityKey === 'all' }"
                @click="setClusterActivity('all')"
              >
                Все тренировки
              </button>
            </li>
            <template v-if="trainingType && trainingType.groups">
              <li
                v-for="item in trainingType.groups.filter(f => f.code == 'running' || f.code == 'walking' || f.code == 'biking' || f.code == 'swimming')"
                :key="'cluster-act-' + item.code"
              >
                <button
                  type="button"
                  class="tabs__item"
                  :class="{ active: clusterActivityKey === item.code }"
                  @click="setClusterActivity(item.code)"
                >
                  <img v-if="item.icon" :src="item.icon.url" style="width: 25px;"
                    :class="{ 'active-icon': clusterActivityKey === item.code }" />
                  {{ item.name }}
                </button>
              </li>
              <li
                v-for="item in trainingType.groups.find(f => f.code == 'winter_sport')?.types.filter(i => i.code == 'cross_skiing')"
                :key="'cluster-act-' + item.code"
              >
                <button
                  type="button"
                  class="tabs__item"
                  :class="{ active: clusterActivityKey === item.code }"
                  @click="setClusterActivity(item.code)"
                >
                  <img v-if="item.icon" :src="item.icon.url" style="width: 25px;"
                    :class="{ 'active-icon': clusterActivityKey === item.code }" />
                  {{ item.name }}
                </button>
              </li>
            </template>
          </ul>
          <div class="tabs-line season__clusters-filter">
            <ul class="tabs-line-content">
              <li>
                <button
                  type="button"
                  class="tabs-line__item"
                  :class="{ active: clusterActiveTab === 'all' }"
                  @click="setClusterTab('all')"
                >
                  Все участники
                </button>
              </li>
              <li>
                <button
                  type="button"
                  class="tabs-line__item"
                  :class="{ active: clusterActiveTab === 'group' }"
                  @click="setClusterTab('group')"
                >
                  Моя группа
                </button>
              </li>
              <li>
                <button
                  type="button"
                  class="tabs-line__item"
                  :class="{ active: clusterActiveTab === 'subunit' }"
                  @click="setClusterTab('subunit')"
                >
                  Мое подразделение
                </button>
              </li>
            </ul>
          </div>
          <div class="season__clusters-picker">
            <span class="season__clusters-picker-label">Кластер:</span>
            <button
              v-for="c in clustersRating"
              :key="'picker-' + c.clusterId"
              type="button"
              class="season__clusters-picker-item"
              :class="{
                'season__clusters-picker-item--active': c.clusterId === activeClusterId,
                'season__clusters-picker-item--me': isClusterMine(c.clusterId),
              }"
              :title="c.label"
              :data-range="c.label"
              @click="selectCluster(c.clusterId)"
            >
              {{ c.clusterId }}
              <span v-if="isClusterMine(c.clusterId)" class="season__clusters-picker-badge">мой</span>
            </button>
            <span class="season__clusters-picker-hint">для активности «{{ clusterActivityName }}»</span>
          </div>
          <div v-if="activeCluster" class="season__cluster" :class="{ 'season__cluster--me': isClusterMine(activeCluster.clusterId) }">
            <h3 class="season__cluster-title">
              Кластер {{ activeCluster.clusterId }}
              <span class="season__cluster-subtitle">({{ activeCluster.label }})</span>
              <span v-if="isClusterMine(activeCluster.clusterId)" class="season__cluster-mine">ваш</span>
            </h3>
            <div class="season__cluster-card">
              <div class="season__cluster-head">
                <span class="season__cluster-place">#</span>
                <span class="season__cluster-name">Участник</span>
                <span class="season__cluster-goal">Цель</span>
                <span class="season__cluster-progress">Пройдено</span>
                <span class="season__cluster-percent">%</span>
              </div>
              <ul class="season__cluster-list" v-if="filterClusterMembers(activeCluster.members).length > 0">
                <li
                  class="season__cluster-item"
                  :class="{ 'season__cluster-item--me': item.isMe }"
                  v-for="item in filterClusterMembers(activeCluster.members)"
                  :key="activeCluster.clusterId + '-' + item.place"
                >
                  <span class="season__cluster-place">{{ item.place }}</span>
                  <span class="season__cluster-name">{{ item.name }}</span>
                  <span class="season__cluster-goal">{{ item.goalKm }}&nbsp;км</span>
                  <span class="season__cluster-progress">{{ item.progressKm }}&nbsp;км</span>
                  <span class="season__cluster-percent">{{ item.percent }}%</span>
                </li>
              </ul>
              <div v-else class="season__cluster-empty">
                <template v-if="clusterActiveTab === 'group'">Нет участников вашей группы в этом кластере</template>
                <template v-else-if="clusterActiveTab === 'subunit'">Нет участников вашего подразделения в этом кластере</template>
                <template v-else>В этом кластере пока нет участников</template>
              </div>
            </div>
          </div>
        </div>
        -->
        </div>
      </section>
    </main>
    <v-dialog />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import InfiniteLoading from 'vue-infinite-loading';
import NoGoalAlert from '@/components/Season/NoGoalAlert.vue'
import ProgressCard from '@/components/Season/ProgressCard.vue'

export default {
  name: 'RatingPage',

  components: {
    InfiniteLoading,
    NoGoalAlert,
    ProgressCard
  },

  data() {
    return {
      viewMode: 'general',
      showDate: false,
      activeMonth: '',
      activePeriod: '',
      loading: false,
      group: null,
      subunit: null,
      showSidebarMonth: false,
      showSidebarSeason: false,
      activeTab: 'all',
      subunitId: null,
      clusterActiveTab: 'all',
      clusterActivityKey: 'all',
      selectedClustersByActivity: {
        all: null,
        running: null,
        walking: null,
        biking: null,
        cross_skiing: null,
      },
    }
  },

  computed: {
    ...mapGetters('rating', ['rating', 'params', 'ratingLoading', 'meta', 'infiniteId', 'repsonal_rating', 'total']),
    ...mapGetters('statistic', ['trainingType']),
    ...mapGetters('season', ['clustersRating', 'myClustersByActivity', 'myClusterIds', 'isGoalSet']),
    myClusterIdForActivity() {
      return this.myClustersByActivity[this.clusterActivityKey] || null
    },
    hasClustersRating() {
      return Array.isArray(this.clustersRating) && this.clustersRating.length > 0
    },
    activeClusterId() {
      if (!this.hasClustersRating) return null
      const fallback = this.myClusterIdForActivity
        || (this.myClusterIds && this.myClusterIds[0])
        || this.clustersRating[0].clusterId
      const targetId = this.selectedClustersByActivity[this.clusterActivityKey] || fallback
      const found = this.clustersRating.find(c => c.clusterId === targetId)
      return found ? found.clusterId : this.clustersRating[0].clusterId
    },
    activeCluster() {
      if (!this.hasClustersRating) return null
      return this.clustersRating.find(c => c.clusterId === this.activeClusterId) || null
    },
    clusterActivityName() {
      if (this.clusterActivityKey === 'all') return 'Все тренировки'
      if (!this.trainingType || !this.trainingType.groups) return ''
      const direct = this.trainingType.groups.find(g => g.code === this.clusterActivityKey)
      if (direct) return direct.name
      const winter = this.trainingType.groups.find(g => g.code === 'winter_sport')
      const sub = winter && winter.types ? winter.types.find(t => t.code === this.clusterActivityKey) : null
      return sub ? sub.name : ''
    },
    monthsArray() {
      const moment = require('moment');
      let startMonth = moment('2025-01-01').month(0);
      let endMonth = moment().startOf('month');
      let months = [];

      while (startMonth.isBefore(endMonth) || startMonth.isSame(endMonth, 'month')) {
        months.push(startMonth.format('YYYY-MM'));
        startMonth.add(1, 'month');
      }

      return months;
    }
  },

  mounted() {
    // const savedValue = localStorage.getItem('selectedValueForRating');

    // if (savedValue) {
    //   if (savedValue === 'летний сезон 2024') {
    //     this.changeParams({
    //       period_from: "2024-05",
    //       period_to: "2024-09",
    //       changeFor: "period_range"
    //     });
    //     this.activePeriod = savedValue
    //     this.activePeriod = savedValue
    //   } else if (savedValue === 'зимний сезон 2025') {
    //     this.changeParams({
    //       period_from: "2025-01",
    //       period_to: "2025-03",
    //       changeFor: "period_range"
    //     });
    //     this.activePeriod = savedValue
    //   } else {
    //     this.activeMonth = this.$moment(savedValue).format("MMMM YYYY");
    //     this.changeParams({
    //       value: savedValue,
    //       changeFor: 'period',
    //     });
    //   }
    // } else {
    //   const paramsDateFormat = this.$moment().format("YYYY-MM");
    //   this.changeParams({
    //     value: paramsDateFormat,
    //     changeFor: 'period',
    //   });
    //   this.activeMonth = this.$moment().startOf('month').format("MMMM YYYY");
    // }
    const paramsDateFormat = this.$moment().format("YYYY-MM");
    this.changeParams({
      value: paramsDateFormat,
      changeFor: 'period',
    });
    this.activeMonth = this.$moment().startOf('month').format("MMMM YYYY");

    this.setActiveTab('all');

    this.group = this.$store.getters['auth/user'].club.references[0] || null
    this.subunit = this.$store.getters['auth/user'].club.references[1] || null

    this.$store.dispatch('season/getSeasonProgress');
  },
  destroyed() {
    this.$store.dispatch('season/clear');
  },
  methods: {
    ...mapActions('rating', ['changeParams', 'getClubRating', 'clear']),
    infiniteHandler($state) {
      if (this.meta?.page.number < this.meta?.page.total) {
        this.getClubRating({loading: false, isInfinite: true, subunitId: this.subunitId, number: this.number, type: this.activeTab } ).then(() => {
          $state.loaded()
        })
      } else {
        $state.complete()
      }
    },
    showModal() {
      this.$modal.show('dialog', {
        text: `Для просмотра данных по вашему подразделению необходимо указать его <a href="/profile" target="_blank">в профиле</a>.`,
        buttons: [
          {
            title: 'Закрыть',
            handler: () => {
              this.$modal.hide('dialog')
            },
          },
        ],
      })
    },
    handleTabChange(tab) {
      this.activeTab = tab;
      this.setActiveTab(tab); 
    },
    async setActiveTab(tab) {
      this.clear()
      this.activeTab = tab;

      if (tab === 'all') {
        this.subunitId = null;
      } else if (tab === 'group') {
        this.subunitId = this.$store.getters['auth/user'].club.references[0] || null;
      } else if (tab === 'subunit') {
        this.subunitId = this.$store.getters['auth/user'].club.references[1] || null;
      }

      await this.$store.dispatch('rating/getClubRating', {
        subunitId: this.subunitId,
        loading: true
      });
    },
    filterClusterMembers(members) {
      if (this.clusterActiveTab === 'group') {
        return members.filter(m => m.inMyGroup)
      }
      if (this.clusterActiveTab === 'subunit') {
        return members.filter(m => m.inMySubunit)
      }
      return members
    },
    setClusterTab(tab) {
      if (tab === 'group' && this.group === null) {
        this.showModal()
        return
      }
      if (tab === 'subunit' && (this.subunit === null || this.group === null)) {
        this.showModal()
        return
      }
      this.clusterActiveTab = tab
    },
    selectCluster(clusterId) {
      this.$set(this.selectedClustersByActivity, this.clusterActivityKey, clusterId)
    },
    setClusterActivity(key) {
      this.clusterActivityKey = key
    },
    isClusterMine(clusterId) {
      if (this.clusterActivityKey === 'all') {
        return this.myClusterIds.includes(clusterId)
      }
      return this.myClusterIdForActivity === clusterId
    },
    toggleShowDate() {
      if (window.innerWidth >= 900) {
        this.showDate = !this.showDate;
        this.showSidebarMonth = false;
        this.showSidebarSeason = false;
      } else {
        this.showDate = true;
      }
    },

    onClickOutside(e) {
      if (!e.target.classList.contains('statistic__title-open')) {
        this.showDate = false
      }
    },
    setTypeAll() {
      this.clear()
      this.loading = true
      this.changeParams({
        value: null,
        changeFor: 'type_group',
      })
      this.changeParams({
        value: null,
        changeFor: 'type',
      })
      this.getClubRating({ loading: true, subunitId: this.subunitId })
        .finally(() => {
          this.loading = false
        })
    },
    setTypeFilter(item, tabType) {
      this.clear()
      this.loading = true
      if (tabType === 'type') {
        this.changeParams({
          value: null,
          changeFor: 'type_group',
        })
      } else {
        this.changeParams({
          value: null,
          changeFor: 'type',
        })
      }
      this.changeParams({
        value: item,
        changeFor: tabType,
      })
      this.getClubRating({ loading: true, subunitId: this.subunitId })
        .finally(() => {
          this.loading = false
        })
    },
    setActiveMonth(date) {
      this.loading = true
      this.activeMonth = this.$moment(date).format("MMMM YYYY")
      this.activePeriod = ''
      this.showDate = false
      const paramsDateFormat = this.$moment(date).format("YYYY-MM")
      localStorage.setItem('selectedValueForRating', paramsDateFormat);
      this.changeParams({
        value: paramsDateFormat,
        changeFor: 'period',
      });
      this.changeParams({
        value: 1,
        changeFor: 'page',
      });
      this.getClubRating({ loading: true, subunitId: this.subunitId })
        .finally(() => {
          this.loading = false
          this.$nextTick(() => {
            this.showDate = false;
          });
        })
    },
    setActivePeriod(season) {
      this.loading = true

      let periodFrom = ''
      let periodTo = ''

      if (season === "summer") {
        periodFrom = "2024-05";
        periodTo = "2024-09";
        this.activePeriod = "летний сезон 2024";
      } else if (season === "winter") {
        periodFrom = "2025-01";
        periodTo = "2025-03";
        this.activePeriod = "зимний сезон 2025";
      } else if (season === "summer2026") {
        periodFrom = "2026-05";
        periodTo = "2026-09";
        this.activePeriod = "летний сезон 2026";
      } else if (season === "summer2025") {
        periodFrom = "2025-05";
        periodTo = "2025-09";
        this.activePeriod = "летний сезон 2025";
      } else if (season === "winter2025-26") {
        periodFrom = "2025-12";
        periodTo = "2026-03";
        this.activePeriod = "зимний сезон 2026";
      }

      this.activeMonth = ''
      this.showDate = false

      localStorage.setItem('selectedValueForRating', this.activePeriod)

      this.changeParams({
        period_from: periodFrom,
        period_to: periodTo,
        changeFor: "period_range"
      });

      this.changeParams({
        value: 1,
        changeFor: 'page',
      });

      this.getClubRating({ loading: true, subunitId: this.subunitId })
        .finally(() => {
          this.loading = false
          this.$nextTick(() => {
            this.showDate = false;
          });
        })
    },
    setAllProject() {
      this.loading = true;
      this.activeMonth = '';
      this.activePeriod = ''
      this.showDate = false
      this.showSidebarMonth = false
      this.showSidebarSeason = false
      this.changeParams({
        period_from: null,
        period_to: null,
        changeFor: "period_range"
      });
      this.changeParams({
        value: null,
        changeFor: 'period',
      });
      this.changeParams({
        value: 1,
        changeFor: 'page',
      });
      this.getClubRating({ loading: true, subunitId: this.subunitId })
        .finally(() => {
          this.loading = false
        })
    },
  }
}
</script>

<style>
.tabs::-webkit-scrollbar {
  visibility: hidden;
  width: 0px;
}

.active-icon {
  filter: invert(1);
}

.loading {
  opacity: 0.7;
  pointer-events: none;
}
.statistic__title >span {
  display: block;
}

.season__view-switcher {
  margin-top: 24px;
}

.season__clusters {
  margin-top: 24px;
  margin-bottom: 40px;
}

.season__clusters-picker {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding: 12px 16px;
  margin-bottom: 24px;
  background: #f4f7fb;
  border-radius: 10px;
}

.season__clusters-picker-label {
  font-size: 13px;
  color: #6b7a8f;
  margin-right: 4px;
}

.season__clusters-picker-item {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 40px;
  height: 34px;
  padding: 0 14px;
  border: 1.5px solid #b0bfcf;
  border-radius: 17px;
  background: #fff;
  color: #012653;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s;
}

.season__clusters-picker-item:hover {
  background: #e9f0f7;
}

.season__clusters-picker-item--me {
  border-color: #c9952a;
}

.season__clusters-picker-item--active {
  background: #012653;
  border-color: #012653;
  color: #fff;
}

.season__clusters-picker-item--active.season__clusters-picker-item--me {
  background: #c9952a;
  border-color: #c9952a;
}

.season__clusters-picker-item:hover::after {
  content: attr(data-range);
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  padding: 4px 8px;
  background: #012653;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  border-radius: 6px;
  pointer-events: none;
  z-index: 10;
}

.season__clusters-picker-item:hover::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 4px solid transparent;
  border-top-color: #012653;
  pointer-events: none;
  z-index: 10;
}

.season__clusters-picker-badge {
  font-size: 11px;
  font-weight: 500;
  color: #c9952a;
  text-transform: lowercase;
}

.season__clusters-picker-item--active .season__clusters-picker-badge {
  color: rgba(255, 255, 255, 0.85);
}

.season__cluster {
  margin-top: 24px;
  margin-bottom: 32px;
}

.season__cluster--me {
  padding: 12px;
  border: 1.5px solid #c9952a;
  border-radius: 14px;
  background: #fffbea;
}

.season__cluster-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
  color: #012653;
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 8px;
}

.season__cluster-subtitle {
  font-weight: 400;
  color: #6b7a8f;
  font-size: 15px;
}

.season__cluster-mine {
  display: inline-block;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #fff;
  background: #c9952a;
  border-radius: 4px;
}

.season__cluster-empty {
  padding: 16px 18px;
  color: #6b7a8f;
  font-size: 14px;
}

.season__cluster-card {
  border: 1.5px solid #b0bfcf;
  border-radius: 12px;
  overflow: hidden;
}

.season__cluster-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 18px;
  background: #fff;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #6b7a8f;
  border-bottom: 1.5px solid #b0bfcf;
}

.season__cluster-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.season__cluster-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 18px;
  border-top: 1px solid #e0e7ef;
  font-size: 14px;
  transition: background 0.15s;
}

.season__cluster-item--me {
  background: #fffbea;
  font-weight: 600;
}

.season__cluster-place {
  min-width: 28px;
  color: #888;
  font-size: 13px;
  flex-shrink: 0;
}

.season__cluster-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.season__cluster-goal,
.season__cluster-progress {
  min-width: 80px;
  text-align: right;
  color: #555;
  flex-shrink: 0;
}

.season__cluster-percent {
  min-width: 52px;
  text-align: right;
  font-weight: 600;
  color: #012653;
  flex-shrink: 0;
}

@media screen and (max-width: 760px) {
  .season__cluster-goal {
    display: none;
  }

  .season__cluster-head .season__cluster-goal {
    display: none;
  }

  .season__clusters-nav {
    position: static;
  }
}

.season__clusters-filter {
  margin: 0 0 24px;
}

.season__cluster-activity {
  margin-top: 0;
  margin-bottom: 16px;
}

.season__clusters-picker-hint {
  margin-left: auto;
  font-size: 13px;
  color: #6b7a8f;
}

@media screen and (max-width: 760px) {
  .season__clusters-picker-hint {
    margin-left: 0;
    flex-basis: 100%;
  }
}
</style>
